/* eslint-disable import/no-unresolved */
import React from 'react';
import SingleBox from '../SoftwareServices/WhatWeDo/WhatWeDoPartials/AboutSingleBox';
import imagesLandingPages from '../imagesLandingPages';
import imagesPillarPages from '../imagesPillarPages';

function HomeIndustries() {
  return (
    <div className="industries main-home-beam">
      <div className="container">
        <div className="subtitle without bigger">
          <h2>Bespoke development services</h2>
          <div className="extra">
            We’re the go-to team for building products and custom software with
            state-of-the-art technology.
          </div>
        </div>
        <div className="software-services">
          <div className="info-box">
            <div className="row">
              <SingleBox
                image={imagesLandingPages.pythonSVG}
                heading="Python development"
                lg
                details={[
                  'The top choice for ',
                  <span style={{ fontWeight: '700' }}>
                    backend development
                  </span>,
                  ' that handles the "behind the scenes" functionality of your application.'
                ]}
                link="/software-services/python-development/"
              />
              <SingleBox
                image={imagesPillarPages.logoJS}
                heading="JavaScript development"
                lg
                details={[
                  'Powerful ',
                  <span style={{ fontWeight: '700' }}>
                    frontend web programming
                  </span>,
                  ' language making webpages highly responsive and dynamic.'
                ]}
                link="/software-services/javascript-development/"
              />
              <SingleBox
                image={imagesPillarPages.graphSVG}
                lg
                heading="Cryptocurrency and trading platforms"
                details="Build the best quality, highly secured cryptocurrency services: digital wallets, smart contracts, or custom blockchain solutions with the highest security standards."
                link="/software-services/cryptocurrency-trading-platforms/"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HomeIndustries;
